<template>
    <div id="app">
        <router-view/>
        <ws></ws>
    </div>
</template>

<script>
import {app} from './main'
import Vue from 'vue'
import ws from '@/components/ws'
import VConsole from 'vconsole';

export default {
    name: 'App',
    data () {
        return {
        }
    },
    components:{
        ws
    },
    methods:{
        //語言
        // changeLang(lang){
        //     app.$i18n.locale=lang
        // },
    },    
    mounted(){
        const vConsole = new VConsole();
    },
    created(){
    }
}
</script>


<style lang="scss">
 @import './assets/scss/all';
</style>




// WEBPACK FOOTER //
// src/App.vue